// features/workstations/shared/building-state.js
// ═══════════════════════════════════════════════════════════
// BUILDING STATE — progress display for any "this becomes
// useful at N items" gate.
//
// Used by Findings (N trades → full Pattern Library), Uploads
// (analysis steps in flight), and any future tab where
// statistical significance / completion needs to be visible
// before the feature unlocks.
//
// Props:
//   current        - integer count so far
//   target         - integer threshold for "fully unlocked"
//   label          - "Trades logged toward first pattern analysis"
//   sub            - explanation text below the bar
//   building       - bool: are we still in the "before threshold" phase?
//                    (drives the label vs the unlocked-message)
//   afterTargetMsg - text to show when current >= target
//   actionLabel    - optional CTA button label
//   onAction       - optional CTA handler
//   actionBusy     - optional loading state
// ═══════════════════════════════════════════════════════════

export default function BuildingState({
  current,
  target,
  label,
  sub,
  afterTargetMsg,
  actionLabel,
  onAction,
  actionBusy,
}) {
  const safeTarget = Math.max(1, target || 1);
  const pct = Math.min(100, Math.round(((current || 0) / safeTarget) * 100));
  const building = (current || 0) < safeTarget;

  return (
    <div className="ws-building-state">
      <div className="ws-bs-stats">
        <div className="ws-bs-num">{current ?? 0}</div>
        <div className="ws-bs-den">of {safeTarget}</div>
      </div>
      <div className="ws-bs-meta">
        <div className="ws-bs-label">
          {building ? label : (afterTargetMsg || 'Threshold reached')}
        </div>
        <div className="ws-bs-bar-wrap">
          <div className="ws-bs-bar" style={{ width: `${pct}%` }} />
        </div>
        {sub && <div className="ws-bs-sub">{sub}</div>}
      </div>
      {actionLabel && onAction && (
        <button
          type="button"
          className="ws-bs-refresh"
          onClick={onAction}
          disabled={!!actionBusy}
        >
          {actionBusy ? 'Working\u2026' : actionLabel}
        </button>
      )}
    </div>
  );
}
